import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsReorderSlidesTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_REORDER_SLIDES;

	get id(): string {
		return TourId.REPORTS__REORDER_SLIDES;
	}

	override get keyForPersistantDone(): string {
		return ReportsReorderSlidesTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				allowStacked: false,
				attachTo: () => {
					return $('.report_nav ol li').eq(1);
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		this.flowTourReportsSlidesService.endAllTours();
		super.onExplicitClose();
	}
}
